// The theme mode is the kit's (ThemeModeProvider in App.tsx): remembered per
// browser once the user picks one, following the OS until then, on <html>
// before the first paint (index.html). This hook is the kit's, re-exported so
// the app's import paths keep resolving.
export { useThemeMode } from "@atomic/ui-kit";
